import { SpotifyProvider, useSpotify } from './context';

export default SpotifyProvider;
export { useSpotify };
